import { ZoneFeature } from '../zones-base-interfaces'

export const BWMjson: ZoneFeature[] = [
    {
        geofence: {
            coordinates: [
                [
                    [-0.764722, 60.664167],
                    [-0.8875, 60.596111],
                    [-0.960833, 60.501944],
                    [-0.921389, 60.418333],
                    [-1.026111, 60.334722],
                    [-1.018333, 60.183333],
                    [-1.166111, 60.056667],
                    [-1.1725, 59.856667],
                    [-1.376111, 59.853889],
                    [-1.339722, 60.015833],
                    [-1.295278, 60.193611],
                    [-1.449444, 60.136111],
                    [-1.671667, 60.217222],
                    [-1.713333, 60.329444],
                    [-1.4625, 60.352778],
                    [-1.425, 60.378889],
                    [-1.635, 60.481111],
                    [-1.4025, 60.685],
                    [-1.2325, 60.635278],
                    [-1.135833, 60.826111],
                    [-1.013056, 60.841944],
                    [-0.965833, 60.951667],
                    [-0.803889, 60.956667],
                    [-0.751667, 60.844444],
                    [-0.764722, 60.664167],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 2 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [-2.406667, 59.2275],
                    [-2.592222, 59.068611],
                    [-2.845556, 59.138611],
                    [-3.136389, 59.343333],
                    [-2.6, 59.356667],
                    [-2.356389, 59.326944],
                    [-2.406667, 59.2275],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 3 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [-3.362778, 59.154722],
                    [-3.168333, 59.145556],
                    [-3.0625, 59.151944],
                    [-2.888611, 59.063333],
                    [-2.720556, 58.916944],
                    [-2.846111, 58.804444],
                    [-2.866667, 58.695556],
                    [-2.9325, 58.715833],
                    [-3.016389, 58.768056],
                    [-3.192222, 58.756389],
                    [-3.398889, 58.768889],
                    [-3.362778, 59.154722],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 4 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [6.914722, 56.863056],
                    [7.007778, 56.755278],
                    [6.558889, 56.792778],
                    [6.55, 56.904444],
                    [6.914722, 56.863056],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 5 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [2.801111, 54.364444],
                    [2.781944, 54.340556],
                    [2.695556, 54.365278],
                    [2.849167, 54.575278],
                    [2.8875, 54.795556],
                    [2.978333, 54.920278],
                    [3.035833, 55.056667],
                    [3.107778, 55.178889],
                    [3.165278, 55.315556],
                    [3.2625, 55.436944],
                    [3.366389, 55.480833],
                    [3.516111, 55.59],
                    [3.883889, 55.739444],
                    [4.016389, 55.817222],
                    [4.395, 55.709167],
                    [4.466111, 55.620278],
                    [4.741667, 55.453056],
                    [4.66, 55.394444],
                    [4.313889, 55.344167],
                    [4.137778, 55.27],
                    [3.970278, 55.135833],
                    [3.879167, 55.0975],
                    [3.711389, 54.963333],
                    [3.620556, 54.925],
                    [3.452778, 54.790833],
                    [3.361667, 54.7525],
                    [3.150833, 54.575278],
                    [3.06, 54.536944],
                    [2.935278, 54.445833],
                    [2.801111, 54.364444],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 6 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [3.3675, 53.930278],
                    [3.3425, 53.823056],
                    [2.850278, 53.843333],
                    [2.771944, 54.181667],
                    [3.098056, 54.23],
                    [3.371111, 54.221667],
                    [3.357778, 53.995556],
                    [3.3675, 53.930278],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 7 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [-2.419167, 49.517222],
                    [-2.478611, 49.381667],
                    [-2.710833, 49.401389],
                    [-2.5075, 49.571111],
                    [-2.419167, 49.517222],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 8 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [-2.052778, 49.085556],
                    [-2.090556, 49.036944],
                    [-2.201111, 49.055556],
                    [-2.238611, 49.1475],
                    [-2.29, 49.232778],
                    [-2.114722, 49.281667],
                    [-2.058056, 49.616111],
                    [-1.942222, 49.496667],
                    [-1.98, 49.141944],
                    [-2.052778, 49.085556],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 9 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [-3.316667, 48.891389],
                    [-3.088056, 48.872222],
                    [-2.935278, 48.7525],
                    [-2.787222, 48.697222],
                    [-2.737778, 48.625833],
                    [-3.919167, 48.625833],
                    [-3.919444, 48.774444],
                    [-3.886111, 48.760556],
                    [-3.574167, 48.795833],
                    [-3.519444, 48.875],
                    [-3.448611, 48.890833],
                    [-3.383889, 48.876111],
                    [-3.316667, 48.891389],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 10 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
    {
        geofence: {
            coordinates: [
                [
                    [11.729167, 54.376111],
                    [11.5275, 54.402778],
                    [11.472778, 54.273333],
                    [11.398889, 54.1475],
                    [11.214722, 54.095],
                    [11.116944, 54.106944],
                    [11.0975, 54.037222],
                    [11.249444, 54.0275],
                    [11.380278, 53.972778],
                    [11.399722, 54.048611],
                    [11.496667, 54.066389],
                    [11.505556, 54.146667],
                    [11.729167, 54.229444],
                    [11.729167, 52.229444],
                    [-2.599167, 48.229444],
                    [-2.597778, 48.625833],
                    [-2.497778, 48.668056],
                    [-2.416111, 48.715833],
                    [-2.282222, 48.754167],
                    [-2.138611, 48.838333],
                    [-2.059167, 48.738889],
                    [-1.874722, 48.761944],
                    [-1.766944, 48.748611],
                    [-1.726389, 48.845278],
                    [-1.655833, 48.965],
                    [-1.686667, 49.213889],
                    [-1.854167, 49.348056],
                    [-1.908056, 49.605],
                    [-1.988889, 49.661389],
                    [-1.918889, 49.739722],
                    [-1.9025, 49.861944],
                    [-1.755833, 49.918333],
                    [-1.683333, 49.745833],
                    [-1.428889, 49.690833],
                    [-1.292778, 49.707778],
                    [-1.188889, 49.695],
                    [-1.209444, 49.531111],
                    [-1.1325, 49.459444],
                    [-0.969444, 49.457222],
                    [-0.796944, 49.435833],
                    [-0.636667, 49.455556],
                    [-0.220278, 49.377222],
                    [-0.001667, 49.664444],
                    [0.098056, 49.744167],
                    [0.305, 49.788889],
                    [0.538611, 49.926389],
                    [0.626111, 49.915278],
                    [0.798611, 49.936944],
                    [0.984722, 49.944444],
                    [1.076389, 50.009444],
                    [1.204722, 50.063333],
                    [1.268889, 50.360833],
                    [1.248333, 50.525556],
                    [1.309167, 50.683333],
                    [1.081667, 50.748333],
                    [0.9925, 50.737222],
                    [0.795, 50.757778],
                    [0.606944, 50.694444],
                    [0.294167, 50.64],
                    [-0.04, 50.7425],
                    [-0.238056, 50.780833],
                    [-0.384722, 50.694444],
                    [-0.5025, 50.645],
                    [-0.812778, 50.418333],
                    [-1.064722, 50.346111],
                    [-1.346111, 50.410278],
                    [-1.505833, 50.526944],
                    [-1.596944, 50.565278],
                    [-1.835, 50.716667],
                    [-2.066389, 50.521944],
                    [-2.148056, 50.483611],
                    [-2.325278, 50.613056],
                    [-2.409444, 50.467222],
                    [-2.578889, 50.488333],
                    [-2.842778, 50.656111],
                    [-2.988611, 50.717778],
                    [-3.101389, 50.651389],
                    [-3.283056, 50.575],
                    [-3.432778, 50.511944],
                    [-3.502778, 50.323611],
                    [-3.575, 50.220278],
                    [-3.773889, 50.181944],
                    [-3.920556, 50.268056],
                    [-3.921944, 50.268333],
                    [-3.927222, 53.395833],
                    [-3.705, 53.411111],
                    [-3.490278, 53.493611],
                    [-3.451111, 53.669722],
                    [-3.625278, 53.887222],
                    [-3.556667, 54.004167],
                    [-3.435, 54.101389],
                    [-3.452222, 54.239722],
                    [-3.709722, 54.445833],
                    [-3.929167, 54.681389],
                    [-3.935833, 58.574444],
                    [-3.792778, 58.586944],
                    [-3.411111, 58.691667],
                    [-3.015278, 58.668056],
                    [-3.020833, 58.523056],
                    [-3.016389, 58.411389],
                    [-3.16, 58.309444],
                    [-3.406389, 58.200556],
                    [-3.524167, 58.061389],
                    [-3.447778, 57.941667],
                    [-3.385556, 57.874722],
                    [-3.272778, 57.77],
                    [-2.468333, 57.743333],
                    [-2.219722, 57.726944],
                    [-2.047222, 57.726944],
                    [-1.827222, 57.684167],
                    [-1.743889, 57.540833],
                    [-1.768889, 57.398611],
                    [-1.902778, 57.335556],
                    [-2.075278, 57.096944],
                    [-2.111111, 56.948611],
                    [-2.158056, 56.814722],
                    [-2.328333, 56.734444],
                    [-2.463333, 56.641667],
                    [-2.5425, 56.474167],
                    [-2.588889, 56.386389],
                    [-2.585556, 56.3025],
                    [-2.499167, 56.173889],
                    [-2.503333, 56.0675],
                    [-2.111111, 55.958333],
                    [-1.900556, 55.796667],
                    [-1.4125, 55.672778],
                    [-1.376667, 55.565],
                    [-1.3825, 55.414444],
                    [-1.520278, 55.338889],
                    [-1.525556, 55.225833],
                    [-1.291389, 55.024444],
                    [-1.293611, 54.965833],
                    [-1.291944, 54.9225],
                    [-1.295278, 54.836667],
                    [-0.963889, 54.6225],
                    [-0.688333, 54.539167],
                    [-0.519167, 54.445833],
                    [-0.343333, 54.362778],
                    [-0.257778, 54.233611],
                    [-0.152778, 54.229444],
                    [0.094722, 54.142778],
                    [0.081944, 53.823056],
                    [0.261111, 53.738333],
                    [0.388056, 53.671389],
                    [0.612778, 53.628333],
                    [0.776111, 53.541944],
                    [1.112778, 53.435278],
                    [1.164167, 53.326389],
                    [1.263333, 53.279444],
                    [1.387778, 53.145278],
                    [1.640278, 53.026111],
                    [1.854167, 52.895278],
                    [1.985, 52.853611],
                    [2.1175, 52.807222],
                    [2.243333, 52.812222],
                    [2.291389, 52.660556],
                    [2.284167, 52.479444],
                    [2.124167, 52.246944],
                    [2.071389, 51.860278],
                    [1.955833, 51.465833],
                    [2.079167, 51.301389],
                    [2.319722, 51.428611],
                    [2.669722, 51.511944],
                    [2.888889, 51.646389],
                    [2.988056, 51.693056],
                    [3.104722, 51.818889],
                    [3.1925, 51.860278],
                    [3.553056, 52.153611],
                    [3.796111, 52.248333],
                    [3.880833, 52.293056],
                    [4.011667, 52.334722],
                    [4.244167, 52.494444],
                    [4.311944, 52.638056],
                    [4.356667, 52.722778],
                    [4.398056, 52.896944],
                    [4.446111, 53.033333],
                    [4.407778, 52.924444],
                    [4.446111, 53.033333],
                    [4.445556, 53.046389],
                    [4.588611, 53.1825],
                    [4.658611, 53.249167],
                    [4.961944, 53.4325],
                    [5.070278, 53.460833],
                    [5.186111, 53.485],
                    [5.215, 53.498056],
                    [5.464722, 53.583333],
                    [5.678889, 53.5875],
                    [6.233889, 53.696111],
                    [6.285833, 53.745833],
                    [6.0475, 54.059722],
                    [6.339722, 54.0175],
                    [6.506111, 53.931667],
                    [7.341667, 53.860556],
                    [7.775556, 53.921389],
                    [7.675278, 54.2225],
                    [7.486667, 54.468611],
                    [6.980556, 54.501667],
                    [6.486389, 54.822222],
                    [6.340278, 54.928056],
                    [6.4425, 55.022778],
                    [6.759167, 55.175],
                    [6.816667, 55.555833],
                    [6.812778, 55.656389],
                    [6.904167, 55.789167],
                    [7.190556, 55.777778],
                    [7.287222, 55.828889],
                    [7.375, 55.870278],
                    [7.459722, 55.915278],
                    [7.750278, 56.028333],
                    [7.643056, 56.616111],
                    [7.968056, 56.882778],
                    [8.025278, 57.004444],
                    [8.189722, 57.156389],
                    [7.9325, 57.217778],
                    [7.935833, 57.298333],
                    [8.179722, 57.413333],
                    [8.947222, 57.252778],
                    [9.334444, 57.388333],
                    [9.270556, 57.509167],
                    [9.273889, 57.595833],
                    [9.184444, 57.638333],
                    [9.187222, 57.708611],
                    [9.323333, 57.7675],
                    [9.443056, 57.638333],
                    [9.711389, 57.553611],
                    [9.885556, 57.645833],
                    [9.831111, 57.853889],
                    [9.789722, 58.021389],
                    [10.111667, 58.072778],
                    [10.464722, 58.165278],
                    [10.651944, 58.071111],
                    [10.952222, 57.896944],
                    [11.068333, 57.855556],
                    [11.2725, 57.761389],
                    [11.426667, 57.595278],
                    [11.493889, 57.553611],
                    [11.423611, 57.822222],
                    [11.431389, 58.021944],
                    [11.376944, 58.125],
                    [11.216389, 58.273889],
                    [11.128056, 58.460833],
                    [10.904167, 58.668333],
                    [10.738333, 58.847222],
                    [10.693611, 58.888611],
                    [10.604444, 59.117778],
                    [10.608889, 59.234444],
                    [10.607222, 59.2775],
                    [10.610833, 59.363889],
                    [10.588611, 59.462778],
                    [10.455278, 59.535556],
                    [10.542222, 59.409444],
                    [10.553056, 59.245833],
                    [10.485556, 59.0825],
                    [10.351667, 58.985556],
                    [10.077778, 58.920278],
                    [9.862778, 58.913333],
                    [9.660278, 58.888611],
                    [9.315278, 58.673056],
                    [9.023056, 58.521944],
                    [8.798056, 58.371389],
                    [8.582222, 58.241944],
                    [8.365, 58.200556],
                    [8.208333, 58.073611],
                    [8.001111, 58.021944],
                    [7.647222, 58.036111],
                    [7.532222, 57.975278],
                    [7.201667, 57.988333],
                    [7.050833, 57.982222],
                    [6.976667, 57.985278],
                    [6.808056, 58.041111],
                    [6.531944, 58.041667],
                    [6.5575, 58.2],
                    [6.338611, 58.241944],
                    [6.253889, 58.286667],
                    [6.036667, 58.371389],
                    [5.952222, 58.416111],
                    [5.778056, 58.4575],
                    [5.455556, 58.690556],
                    [5.485833, 58.994722],
                    [5.615, 59.061111],
                    [5.5875, 59.214444],
                    [5.396389, 59.215833],
                    [5.229722, 59.084167],
                    [5.150833, 59.062778],
                    [5.089722, 59.326389],
                    [5.109167, 59.3825],
                    [5.179444, 59.409167],
                    [5.151111, 59.536111],
                    [5.196667, 59.601111],
                    [5.110833, 59.6025],
                    [5.068333, 59.642778],
                    [5.044444, 59.800556],
                    [5.046389, 59.883611],
                    [5.184722, 60.103611],
                    [5.211389, 60.189167],
                    [4.938611, 60.199722],
                    [4.902222, 60.342778],
                    [4.971389, 60.409167],
                    [4.888611, 60.562222],
                    [4.843056, 60.701667],
                    [4.934167, 60.882222],
                    [4.891667, 60.930556],
                    [4.931111, 61.023056],
                    [4.726389, 61.024722],
                    [4.703611, 61.129167],
                    [4.752222, 61.193056],
                    [4.952222, 61.229167],
                    [4.944722, 61.405278],
                    [5.071944, 61.525],
                    [5.026667, 61.535556],
                    [4.943056, 61.625],
                    [4.8725, 61.6725],
                    [4.709722, 61.879722],
                    [4.832222, 61.934722],
                    [5.052778, 61.963333],
                    [11.725556, 61.963333],
                    [11.729167, 54.376111],
                ],
            ],
            type: 'Polygon',
        },
        location_name: 'Zone 11 - BWM.2/Circ.56 - Ballast Water Management',
        facility_type: 'BWM',
        properties: [
            {
                description: 'BWM Convention',
            },
        ],
    },
]
